import {useMutation, useQueryClient} from "@tanstack/react-query";

import {errorHandler} from "@/src/modules/core/lib";

import {panicAlertsService} from "../services";
import type {PanicConfirmPayload, PanicIntentPayload} from "../types";

export function usePanicIntent() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PanicIntentPayload) => panicAlertsService.createIntent(payload),
    onError: errorHandler,
    onSuccess: () => {
      void queryClient.invalidateQueries({queryKey: ["panic-alerts"]});
    },
  });
}

export function usePanicConfirm() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PanicConfirmPayload) => panicAlertsService.confirmIntent(payload),
    onError: errorHandler,
    onSuccess: () => {
      void queryClient.invalidateQueries({queryKey: ["panic-alerts"]});
      void queryClient.invalidateQueries({queryKey: ["panic-alert-statistics"]});
    },
  });
}

export function usePanicCancel() {
  return useMutation({
    mutationFn: (intentToken: string) => panicAlertsService.cancelIntent(intentToken),
    onError: errorHandler,
  });
}
